export default "__VITE_ASSET__a743e34a__"